import UserPersistence from "@/persistence/UserPersistence";
export const moduleId = 'job-salary';

export const state = {
    orgId: UserPersistence.getOrgId(),
    isShow: true,
    JobSalaryDetails: '',
    JobSalaryId: '',
    abId: '',
    accountInfo: {},
    routerUrl: '',
    isView: false,
    disable: false,
    buttonType: '',
    params: null,
    billCode: ''
}
export const mutations = {
    setJobSalaryDetails(state, data) {
        state.JobSalaryDetails = data
    },
    setJobSalaryIsShow(state, flag) {
        state.isShow = flag
    },
    setOrgId(state, id) {
        state.orgId = id
    },
    setJobSalaryId(state, data) {
        state.JobSalaryId = data.id
        state.abId = data.abId
    },
    setAccountInfo(state, data) {
        state.accountInfo = data
    },
    setJobSalaryRouterUrl(state, url) {
        state.routerUrl = url
    },
    setJobSalaryIsView(state, flag) {
        state.isView = flag
    },
    setJobSalaryDisable(state, flag) {
        state.disable = flag
    },
    setButtonType(state, type) {
        state.buttonType = type
    },

    setParams(state, data) {
        state.params = data
    },
    setBillCode(state, code) {
        state.billCode = code
    }
}
export const actions = {}


// WEBPACK FOOTER //
// ./src/store/modules/billing-center/job-salary/index.js